import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { useStore } from "vuex";
import { TITLE_PAGE_INDEX, FLOOR_NAME_DEPTH_MAPPING } from "@/libs/constants/constants";
import _ from "lodash";
import { onBeforeMount } from "vue";
import { ClientsService } from "./libs/clients.service";
import { CanvasService } from "./libs/canvas.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

// Define document title
document.title = TITLE_PAGE_INDEX;

onBeforeMount(async () => {
  store.commit("mutationSetIsAllDataLoaded", false);

  await store.dispatch("actionParseRocades");
  await store.dispatch("actionParseFirstData");
  await store.dispatch("actionSetAllDifferentPhases");
  await store.dispatch("actionSetAllReferencesPhases");

  let floorPlans = await CanvasService.preloadAllFloorPlans();
  store.commit("mutationAllPreloadedFloorPlans", floorPlans);

  let tempFloors = [];
  Object.values(FLOOR_NAME_DEPTH_MAPPING).forEach((floorNb) => {
    return tempFloors.push({ nb: floorNb, checked: true })
  }
  );

  store.dispatch("actionInitFloorsVisibility", tempFloors);
  const allDifferentClients = ClientsService.getAllDifferentClients();
  store.dispatch("actionSetActivatedClients2D", allDifferentClients);
  store.dispatch("actionSetActivatedClients2DPhases", allDifferentClients);
  store.dispatch("actionSetAllDifferentClients", allDifferentClients);
  await store.dispatch("actionInitClientsVisibility", allDifferentClients);

  const generalVisibleData = store.getters.getGeneralData;
  store.dispatch("actionSetActivatedFloors2D", [
    ...Object.keys(generalVisibleData),
  ]);
  store.dispatch("actionSetActivatedFloors2DPhases", [
    ...Object.keys(generalVisibleData),
  ]);
  store.commit("mutationSetIsAllDataLoaded", true);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component }) => [
      (_openBlock(), _createBlock(_KeepAlive, null, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
      ], 1024))
    ]),
    _: 1
  }))
}
}

})